// checks if an array of objects has an object with a specific value on a specific key
export const hasObjectWith = (arr, key, value) =>
  arr.reduce(
    (hasMatch, nextObj) => hasMatch || nextObj?.[key] === value,
    false,
  );
